import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { LoginAnnouncementMutationKeys } from '../../../keys'
import {
	UpdateLoginAnnouncementRequest,
	UpdateLoginAnnouncementResponse,
} from '../../../type'
import { updateLoginAnnouncement } from '../../services'

interface UseMutationUpdateLoginAnnouncementProps {
	id: string
	payload: UpdateLoginAnnouncementRequest
}

export default function useMutationUpdateLoginAnnouncement(
	props?: UseBaseMutationOptions<
		UpdateLoginAnnouncementResponse,
		UseMutationUpdateLoginAnnouncementProps
	>,
) {
	return useMutation({
		mutationKey: [LoginAnnouncementMutationKeys.UpdateLoginAnnouncement],
		mutationFn: (params) => updateLoginAnnouncement(params.id, params.payload),
		...props,
	})
}
